import { z } from 'zod'

import { codePointLength } from '~/libs/codePoint'

/** 差戻し理由の上限 (文字数)。 proto の `reason` の `max_len` と同値 (input-character-limits.md の説明・メモ系)。 */
export const REJECT_REASON_MAX_LENGTH = 100

/**
 * 差戻しダイアログのフォームスキーマ。
 *
 * 差戻し理由は必須 (approval-tasks.md AC-009 / spot-bidding.md AC-BSP-063)。
 * backend も REJECT 時に reason 非空を検証する (= 空文字は CodeInvalidArgument)
 * ため、 UI 側で先に塞いで理由の分かるエラーにする。
 *
 * 上限は 100 文字 (approval-tasks.md の差戻しコメントと同じ)。 BFF の protovalidate
 * (`string.max_len`) が文字数 (コードポイント) で数えるので、 UI も UTF-16 の長さでなく
 * コードポイントで数える。
 */
export const rejectFormSchema = z.object({
  reason: z
    .string()
    .min(1, '差戻し理由を入力してください')
    .refine(
      (value) => codePointLength(value) <= REJECT_REASON_MAX_LENGTH,
      `差戻し理由は${REJECT_REASON_MAX_LENGTH}文字以内で入力してください`,
    ),
})

export type RejectFormValues = z.infer<typeof rejectFormSchema>
